import { createLucideIcon } from 'lucide-react'

// lucide ships `circle-dollar-sign` but has no struck-through variant of it, so
// this composes one in lucide's own idiom: the exact icon node from
// `circle-dollar-sign` plus the standard "-off" slash (`m2 2 20 20`) that
// bell-off, eye-off and the rest all use. Same 24×24 grid, same stroke, so it
// sits beside the paid icon without looking bolted on.
//
// The path data is copied rather than imported because lucide-react exports the
// rendered component, not its node — `__iconNode` lives behind a deep path that
// isn't part of the package's public surface.
export const CircleDollarSignOff = createLucideIcon('circle-dollar-sign-off', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8', key: '1h4pet' }],
  ['path', { d: 'M12 18V6', key: 'zqpxq5' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
])
